// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.15.3
//   protoc               v7.36.2
// source: proto/common.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "protobuf.variables";

/**
 * Semantic type of a variable value.
 * The oneof inside VariableValue describes the wire type (string, number, bool);
 * this enum describes what the value *means* (e.g. is this string a shipment ID?).
 */
export enum VariableType {
  /** STRING - Plain string */
  STRING = 0,
  NUMBER = 1,
  BOOL = 2,
  /** SHIPMENT - Value is a shipment UUID */
  SHIPMENT = 3,
  /** ALERT - Value is an alert UUID */
  ALERT = 4,
  /**
   * ALERT_TYPE - ALERT_TYPE is not stored in VariableValue protos — it's used by the frontend meta-variable
   * catalog to identify fields whose values are alert-type enum strings.
   */
  ALERT_TYPE = 5,
  /** DATE_TIME - Timezone-aware instant; carried in DateTimeValue */
  DATE_TIME = 6,
  /** TEXT - Multi-line plain text (stored as string_value; frontend-only semantic type) */
  TEXT = 7,
  /** TRANSPORT_PROVIDER - Value is a CompanyCourier UUID */
  TRANSPORT_PROVIDER = 8,
  /** DATE_TIME_RANGE - Timezone-aware start/end window; carried in DateTimeRangeValue */
  DATE_TIME_RANGE = 9,
  /** SENTIMENT - How the AI judged the tone of a call */
  SENTIMENT = 10,
  /** ETA_DIRECTION - Whether a shipment's ETA moved earlier or later */
  ETA_DIRECTION = 11,
  /** ALERT_STATUS - Whether an alert is active, resolved or dismissed */
  ALERT_STATUS = 12,
  /** INBOUND_EVENT_TYPE - What kind of inbound event started the workflow */
  INBOUND_EVENT_TYPE = 13,
  /** ACTION_TAKEN - How an alert was resolved/dismissed (manual, AI, or system) */
  ACTION_TAKEN = 14,
  UNRECOGNIZED = -1,
}

export function variableTypeFromJSON(object: any): VariableType {
  switch (object) {
    case 0:
    case "STRING":
      return VariableType.STRING;
    case 1:
    case "NUMBER":
      return VariableType.NUMBER;
    case 2:
    case "BOOL":
      return VariableType.BOOL;
    case 3:
    case "SHIPMENT":
      return VariableType.SHIPMENT;
    case 4:
    case "ALERT":
      return VariableType.ALERT;
    case 5:
    case "ALERT_TYPE":
      return VariableType.ALERT_TYPE;
    case 6:
    case "DATE_TIME":
      return VariableType.DATE_TIME;
    case 7:
    case "TEXT":
      return VariableType.TEXT;
    case 8:
    case "TRANSPORT_PROVIDER":
      return VariableType.TRANSPORT_PROVIDER;
    case 9:
    case "DATE_TIME_RANGE":
      return VariableType.DATE_TIME_RANGE;
    case 10:
    case "SENTIMENT":
      return VariableType.SENTIMENT;
    case 11:
    case "ETA_DIRECTION":
      return VariableType.ETA_DIRECTION;
    case 12:
    case "ALERT_STATUS":
      return VariableType.ALERT_STATUS;
    case 13:
    case "INBOUND_EVENT_TYPE":
      return VariableType.INBOUND_EVENT_TYPE;
    case 14:
    case "ACTION_TAKEN":
      return VariableType.ACTION_TAKEN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return VariableType.UNRECOGNIZED;
  }
}

export function variableTypeToJSON(object: VariableType): string {
  switch (object) {
    case VariableType.STRING:
      return "STRING";
    case VariableType.NUMBER:
      return "NUMBER";
    case VariableType.BOOL:
      return "BOOL";
    case VariableType.SHIPMENT:
      return "SHIPMENT";
    case VariableType.ALERT:
      return "ALERT";
    case VariableType.ALERT_TYPE:
      return "ALERT_TYPE";
    case VariableType.DATE_TIME:
      return "DATE_TIME";
    case VariableType.TEXT:
      return "TEXT";
    case VariableType.TRANSPORT_PROVIDER:
      return "TRANSPORT_PROVIDER";
    case VariableType.DATE_TIME_RANGE:
      return "DATE_TIME_RANGE";
    case VariableType.SENTIMENT:
      return "SENTIMENT";
    case VariableType.ETA_DIRECTION:
      return "ETA_DIRECTION";
    case VariableType.ALERT_STATUS:
      return "ALERT_STATUS";
    case VariableType.INBOUND_EVENT_TYPE:
      return "INBOUND_EVENT_TYPE";
    case VariableType.ACTION_TAKEN:
      return "ACTION_TAKEN";
    case VariableType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Who declared a variable. Stored inside a workflow on every VariableRef, so it
 * lives here rather than in variable_schema.proto.
 */
export enum VariableSource {
  /**
   * SOURCE_UNSPECIFIED - Not yet known. A reference built from a node id and a variable name has this
   * source until it's matched to a variable the node publishes. Publish validation
   * rejects it.
   */
  SOURCE_UNSPECIFIED = 0,
  /** SOURCE_NODE_TYPE - The owning node's type, in variable_definitions.json. */
  SOURCE_NODE_TYPE = 1,
  /** SOURCE_USER - The workflow author, in LBNodeData.user_variables. */
  SOURCE_USER = 2,
  /** SOURCE_SYSTEM - The runtime, under the reserved "system" node id. Today that's system.now. */
  SOURCE_SYSTEM = 3,
  UNRECOGNIZED = -1,
}

export function variableSourceFromJSON(object: any): VariableSource {
  switch (object) {
    case 0:
    case "SOURCE_UNSPECIFIED":
      return VariableSource.SOURCE_UNSPECIFIED;
    case 1:
    case "SOURCE_NODE_TYPE":
      return VariableSource.SOURCE_NODE_TYPE;
    case 2:
    case "SOURCE_USER":
      return VariableSource.SOURCE_USER;
    case 3:
    case "SOURCE_SYSTEM":
      return VariableSource.SOURCE_SYSTEM;
    case -1:
    case "UNRECOGNIZED":
    default:
      return VariableSource.UNRECOGNIZED;
  }
}

export function variableSourceToJSON(object: VariableSource): string {
  switch (object) {
    case VariableSource.SOURCE_UNSPECIFIED:
      return "SOURCE_UNSPECIFIED";
    case VariableSource.SOURCE_NODE_TYPE:
      return "SOURCE_NODE_TYPE";
    case VariableSource.SOURCE_USER:
      return "SOURCE_USER";
    case VariableSource.SOURCE_SYSTEM:
      return "SOURCE_SYSTEM";
    case VariableSource.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** One selectable value of a fixed-set type. */
export interface EnumValue {
  /** What's stored and compared, e.g. "tracking_link". */
  value: string;
  /** What an author sees, e.g. "Tracking link". */
  label: string;
}

/** Every value a fixed-set type allows. */
export interface EnumSchema {
  type: VariableType;
  values: EnumValue[];
}

/**
 * What a variable is: its name, its type, and how it's presented in the editor.
 * Covers the declarations that ship with the product, in the variable definitions file, and the
 * ones a workflow author writes on a node.
 */
export interface VariableDesc {
  /**
   * Identifier used in template / variable references (ASCII letters,
   * digits, underscores; cannot start with a digit). E.g. "shipment_id".
   */
  name: string;
  /** Human-readable label shown in editor UI. */
  display_name: string;
  /** Semantic type of the value published at runtime. */
  type: VariableType;
  /** Human-readable description of what the variable represents. */
  description: string;
  /**
   * Values an author pinned for an enum-type variable. A variable the product declares takes its
   * values from the definitions file's enums section instead.
   */
  choices: string[];
  /** Example value shown in the Logiblocks variable picker. */
  sample_value: string;
  /** Whether the value is a list rather than a single value. */
  is_multi_select: boolean;
}

function createBaseEnumValue(): EnumValue {
  return { value: "", label: "" };
}

export const EnumValue: MessageFns<EnumValue> = {
  encode(message: EnumValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.value !== "") {
      writer.uint32(10).string(message.value);
    }
    if (message.label !== "") {
      writer.uint32(18).string(message.label);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnumValue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseEnumValue();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.value = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.label = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): EnumValue {
    return {
      value: isSet(object.value) ? globalThis.String(object.value) : "",
      label: isSet(object.label) ? globalThis.String(object.label) : "",
    };
  },

  toJSON(message: EnumValue): unknown {
    const obj: any = {};
    if (message.value !== "") {
      obj.value = message.value;
    }
    if (message.label !== "") {
      obj.label = message.label;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EnumValue>, I>>(base?: I): EnumValue {
    return EnumValue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EnumValue>, I>>(object: I): EnumValue {
    const message = createBaseEnumValue();
    message.value = object.value ?? "";
    message.label = object.label ?? "";
    return message;
  },
};

function createBaseEnumSchema(): EnumSchema {
  return { type: 0, values: [] };
}

export const EnumSchema: MessageFns<EnumSchema> = {
  encode(message: EnumSchema, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    for (const v of message.values) {
      EnumValue.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnumSchema {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseEnumSchema();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.type = reader.int32() as any;
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.values.push(EnumValue.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): EnumSchema {
    return {
      type: isSet(object.type) ? variableTypeFromJSON(object.type) : 0,
      values: globalThis.Array.isArray(object?.values) ? object.values.map((e: any) => EnumValue.fromJSON(e)) : [],
    };
  },

  toJSON(message: EnumSchema): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = variableTypeToJSON(message.type);
    }
    if (message.values?.length) {
      obj.values = message.values.map((e) => EnumValue.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EnumSchema>, I>>(base?: I): EnumSchema {
    return EnumSchema.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EnumSchema>, I>>(object: I): EnumSchema {
    const message = createBaseEnumSchema();
    message.type = object.type ?? 0;
    message.values = object.values?.map((e) => EnumValue.fromPartial(e)) || [];
    return message;
  },
};

function createBaseVariableDesc(): VariableDesc {
  return {
    name: "",
    display_name: "",
    type: 0,
    description: "",
    choices: [],
    sample_value: "",
    is_multi_select: false,
  };
}

export const VariableDesc: MessageFns<VariableDesc> = {
  encode(message: VariableDesc, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.display_name !== "") {
      writer.uint32(18).string(message.display_name);
    }
    if (message.type !== 0) {
      writer.uint32(24).int32(message.type);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    for (const v of message.choices) {
      writer.uint32(42).string(v!);
    }
    if (message.sample_value !== "") {
      writer.uint32(50).string(message.sample_value);
    }
    if (message.is_multi_select !== false) {
      writer.uint32(56).bool(message.is_multi_select);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableDesc {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseVariableDesc();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.name = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.display_name = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.type = reader.int32() as any;
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.description = reader.string();
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.choices.push(reader.string());
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.sample_value = reader.string();
            continue;
          }
          case 7: {
            if (tag !== 56) {
              break;
            }

            message.is_multi_select = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): VariableDesc {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      display_name: isSet(object.displayName)
        ? globalThis.String(object.displayName)
        : isSet(object.display_name)
        ? globalThis.String(object.display_name)
        : "",
      type: isSet(object.type) ? variableTypeFromJSON(object.type) : 0,
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      choices: globalThis.Array.isArray(object?.choices) ? object.choices.map((e: any) => globalThis.String(e)) : [],
      sample_value: isSet(object.sampleValue)
        ? globalThis.String(object.sampleValue)
        : isSet(object.sample_value)
        ? globalThis.String(object.sample_value)
        : "",
      is_multi_select: isSet(object.isMultiSelect)
        ? globalThis.Boolean(object.isMultiSelect)
        : isSet(object.is_multi_select)
        ? globalThis.Boolean(object.is_multi_select)
        : false,
    };
  },

  toJSON(message: VariableDesc): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.display_name !== "") {
      obj.displayName = message.display_name;
    }
    if (message.type !== 0) {
      obj.type = variableTypeToJSON(message.type);
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.choices?.length) {
      obj.choices = message.choices;
    }
    if (message.sample_value !== "") {
      obj.sampleValue = message.sample_value;
    }
    if (message.is_multi_select !== false) {
      obj.isMultiSelect = message.is_multi_select;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VariableDesc>, I>>(base?: I): VariableDesc {
    return VariableDesc.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VariableDesc>, I>>(object: I): VariableDesc {
    const message = createBaseVariableDesc();
    message.name = object.name ?? "";
    message.display_name = object.display_name ?? "";
    message.type = object.type ?? 0;
    message.description = object.description ?? "";
    message.choices = object.choices?.map((e) => e) || [];
    message.sample_value = object.sample_value ?? "";
    message.is_multi_select = object.is_multi_select ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
